export default __webpack_public_path__ + "static/media/background.7dc9dceb.png";